import type { Engine } from "../../../../royalur/engine/Engine.js";
import { BoardDirective } from "./BoardDirective.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import type { Move } from "../../../../royalur/model/Move.js";
import type { MoveCategory } from "../../../analysis/MoveCategory.js";
import type { GameState } from "../../../../royalur/engine/state/GameState.js";


export interface MoveHighlight {
    move: Move;
    category: MoveCategory;
}


/**
 * A directive for rendering the dice.
 */
export class AnalysisBoardDirective extends BoardDirective {
    readonly activePlayer: PlayerType;
    readonly state: GameState;
    readonly previewMove: Move;
    readonly moveHighlights: MoveHighlight[];

    constructor(
        directiveID: number,
        rules: Engine,
        moveIndex: number,
        activePlayer: PlayerType,
        state: GameState,
        previewMove: Move,
        moveHighlights: MoveHighlight[],
    ) {
        super(directiveID, rules, moveIndex);
        this.activePlayer = activePlayer;
        this.state = state;
        this.previewMove = previewMove;
        this.moveHighlights = moveHighlights;
    }

    isLimboDirective(): boolean {
        return true;
    }

    override getState(): GameState {
        return this.state;
    }

    override getActivePlayer(): PlayerType {
        return this.activePlayer;
    }
}
